import { render, staticRenderFns } from "./organuser.vue?vue&type=template&id=32c6555a&scoped=true&"
import script from "./organuser.vue?vue&type=script&lang=js&"
export * from "./organuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6555a",
  null
  
)

export default component.exports